export const environment = {
  envName:'UAT'
};
